import { AxiosGETRequest, AxiosMutationRequest, RequestMethod } from '@myme/utils';

export const uploadUserAvatarAPI: AxiosMutationRequest = {
  method: RequestMethod.POST,
  path: '/user-context/profile-image'
};

export const uploadDesktopAuthorBannerAPI: AxiosMutationRequest = {
  method: RequestMethod.POST,
  path: '/user-context/banner-desktop'
};

export const uploadMobileAuthorBannerAPI: AxiosMutationRequest = {
  method: RequestMethod.POST,
  path: '/user-context/banner-mobile'
};

export const getAdditionalUserInformationAPI: AxiosGETRequest = {
  method: RequestMethod.GET,
  cacheKeys: ['getAdditionalUserInformationAPI'],
  path: '/user-context/me'
};

export const getUserAvatarAPI: AxiosGETRequest = {
  method: RequestMethod.GET,
  cacheKeys: ['getUserAvatarAPI'],
  path: '/user-context/profile-image'
};

export const getAuthorProfileAPI: AxiosGETRequest = {
  method: RequestMethod.GET,
  cacheKeys: ['getAuthorProfileAPI'],
  path: '/user-context/author/:authorId'
};

export const getAuthorProfileMymesAPI: AxiosGETRequest = {
  method: RequestMethod.GET,
  cacheKeys: ['getAuthorProfileMymesAPI'],
  path: '/myme/author/:authorId/created'
};

export const postUserProfileAPI: AxiosMutationRequest = {
  method: RequestMethod.POST,
  path: '/user-context'
};

export const deleteMeAPI: AxiosMutationRequest = {
  method: RequestMethod.DELETE,
  path: '/user-context/me/'
};

export const postEmailChangeAPI: AxiosMutationRequest = {
  method: RequestMethod.POST,
  path: '/user-context/change-email'
};

export const patchEmailActivationAPI: AxiosMutationRequest = {
  method: RequestMethod.PATCH,
  path: '/user-context/activate-email'
};

export const patchFCMTokenAPI: AxiosMutationRequest = {
  method: RequestMethod.PATCH,
  path: '/user-context/update-fcm-token'
};
